<template functional>
  <div
    v-tooltip="props.tooltip"
    class="LmActorCircle"
    :class="[data.class, data.staticClass, 'text-' + props.color]"
  />
</template>

<script>
export default {
  name: 'LmActorCircle',
  props: {
    color: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.LmActorCircle {
  display: inline-flex;
  &:before {
    content: '';
    flex: none;
    width: 16px;
    height: 16px;
    border: 2px solid;
    border-radius: 9999px;
  }
}
</style>
